import { IActionContext } from '@msdyn365-commerce/core';
import { IPredefinedRefinerHandler } from '../predefined-refiners';
import { getHandler as getConceptHandler } from './concept';
import { getHandler as getHkjottAgreementHandler } from './hkjott-agreement';

export default function getHandlers(context: IActionContext): IPredefinedRefinerHandler[] {
    return [
        getConceptHandler(context),
        getHkjottAgreementHandler(context)
    ].filter(Boolean) as IPredefinedRefinerHandler[];
}
